import React, { useRef, useState, useEffect } from 'react';
import { createUseStyles } from 'react-jss';
import theme from '../../constants/Theme';
import Emotion from '../Emotion/Emotion';
import { getRatingDescription } from '../../helpers/descriptionHelpers';

interface RatingProps {
  index: number;
}

const Rating: React.FC<RatingProps> = ({ index }) => {
  const classes = useStyles();
  const ref = useRef<HTMLDivElement>(null);
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    const element = ref.current;
    const observer = new ResizeObserver(([entry]) => {
      const width = entry.contentRect.width;
      if (width < 166) {
        setIsHidden(true);
      } else {
        setIsHidden(false);
      }
    });

    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  return (
    <div className={classes.container} ref={ref}>
      <Emotion index={index} />
      <span className={classes.description} style={{ display: isHidden ? 'none' : 'block' }}>
        {getRatingDescription(index)}
      </span>
    </div>
  );
};

const useStyles = createUseStyles({
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto 1fr',
    alignItems: 'center',
    gap: 10,
    overflow: 'hidden',
  },
  description: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontSize: 12,
    color: theme.colors.contrastBlack,
  },
});

export default Rating;
